import { H3 } from "melodies-source/Text";
import { FlatCard, NoData } from ".";
import { PieChart } from "Components/PieChart";
import { Metric } from "../aggregate";
import { useTheme } from "styled-components";

interface ClicksBySectionProps {
  metrics?: Metric[];
}

export const ClicksBySection = ({
  metrics,
  ...props
}: ClicksBySectionProps) => {
  const theme = useTheme();
  return (
    <FlatCard {...props}>
      <H3>Clicks by Section</H3>
      {metrics?.length ? (
        <PieChart
          dataKey="clicks"
          nameKey="label"
          data={metrics}
          style={{ textTransform: "capitalize" }}
          colors={theme.custom?.charts?.donut.colors}
        />
      ) : (
        <NoData />
      )}
    </FlatCard>
  );
};
